'use client';

import { useState, useEffect, useRef } from 'react';

interface MetricsCounterProps {
  endValue: number;
  label: string;
  suffix?: string;
}

export default function MetricsCounter({ endValue, label, suffix = '' }: MetricsCounterProps) {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000;
    const steps = 60;
    const increment = endValue / steps;
    let current = 0;

    const timer = setInterval(() => {
      current += increment;
      if (current >= endValue) {
        setCount(endValue);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [isVisible, endValue]);

  return (
    <div data-component-id="src/app/homepage/components/MetricsCounter.tsx:59:4" data-component-path="src/app/homepage/components/MetricsCounter.tsx" data-component-line="59" data-component-end-line="64" data-component-file="MetricsCounter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20animate-countUp%22%7D" ref={ref} className="text-center animate-countUp">
      <div data-component-id="src/app/homepage/components/MetricsCounter.tsx:60:6" data-component-path="src/app/homepage/components/MetricsCounter.tsx" data-component-line="60" data-component-end-line="62" data-component-file="MetricsCounter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-5xl%20md%3Atext-6xl%20font-serif%20font-bold%20text-primary%20mb-2%22%7D" className="text-5xl md:text-6xl font-serif font-bold text-primary mb-2">
        {count.toLocaleString()}{suffix}
      </div>
      <p data-component-id="src/app/homepage/components/MetricsCounter.tsx:63:6" data-component-path="src/app/homepage/components/MetricsCounter.tsx" data-component-line="63" data-component-end-line="63" data-component-file="MetricsCounter.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted-foreground%20text-sm%20uppercase%20tracking-wider%22%7D" className="text-muted-foreground text-sm uppercase tracking-wider">{label}</p>
    </div>
  );
}